/**
 * Standart metin şablonları (28.10.2026, Ürün Sahibi kararı): satışçı "Planlama" ve "İşleyiş" bloklarına hazır metin ekler,
 * sonra düzenler. Metinler MBD'nin herkese gönderdiği standart akıştan çıkarıldı: Onur Bey belgesindeki müşteriye özel
 * olmayan kalıplar (havalimanında karşılama, otele yerleştirme, şoförlü araç tahsisi, tur günleri, havalimanına bırakma)
 * ve mevcut teklif PDF'inin standart cümleleri ("Müsaitlik ve fiyat rezervasyon anında yeniden teyit edilir ...",
 * "Tarih ve saat satış sonrası operasyon tarafından planlanır", "rezervasyon onayı değildir").
 * KURAL: müşteriye özel ifade (aile, uyruk, vize, tarih, otel adı) şablona GİRMEZ; `hizli-teklif-sablonlar.spec.ts` kilitler.
 * Her satır PDF'te blokta ayrı madde olur.
 */
export type SablonGrubu = 'PLANLAMA' | 'ISLEYIS';

export interface StandartSablon {
  readonly kimlik: string;
  readonly grup: SablonGrubu;
  readonly baslik: string;
  readonly metin: string;
}

export const GRUP_BASLIGI: Readonly<Record<SablonGrubu, string>> = { PLANLAMA: 'Planlama', ISLEYIS: 'İşleyiş' };

export const STANDART_SABLONLAR: readonly StandartSablon[] = [
  {
    kimlik: 'karsilama-konaklama-ayrilis',
    grup: 'PLANLAMA',
    baslik: 'Karşılama, konaklama ve ayrılış',
    metin: [
      'Varış günü misafirlerimiz havalimanında karşılanır ve otele yerleştirilir.',
      'Kalış süresince şoförlü araç tahsis edilir.',
      'Ayrılış günü misafirlerimiz havalimanına bırakılır.',
    ].join('\n'),
  },
  {
    kimlik: 'tur-aktivite-gunleri',
    grup: 'PLANLAMA',
    baslik: 'Tur ve aktivite günleri',
    metin: [
      'Programdaki tur ve aktiviteler kalış süresine dağıtılır.',
      'Şehir turları ve ek aktivite günleri isteğe göre eklenebilir.',
      'Tur ve aktivite tarihleri ve saatleri satış sonrası operasyon tarafından planlanır.',
    ].join('\n'),
  },
  {
    kimlik: 'varistan-ayrilisa-akis',
    grup: 'ISLEYIS',
    baslik: 'Varıştan ayrılışa akış',
    metin: [
      'Varış günü: Misafirlerimizi havalimanında karşılar ve otellerine yerleştiririz.',
      'Kalış süresince: Şoförlü araç tahsis ederiz. Tur günlerinde tüm turlar bu araçla yapılır; kalan günlerde araç misafirlerimizin alışveriş ve kişisel aktiviteleri için hizmetindedir.',
      'Ayrılış günü: Misafirlerimizi havalimanına bırakırız.',
    ].join('\n'),
  },
  {
    kimlik: 'soforlu-arac-tahsisi',
    grup: 'ISLEYIS',
    baslik: 'Şoförlü araç tahsisi',
    metin: [
      'Kalış süresince misafirlerimize şoförlü araç tahsis ederiz.',
      'Araç tur günlerinde turlar için, diğer günlerde alışveriş ve kişisel aktiviteler için kullanılır.',
      'Tüm turlarımız tahsis edilen araçla gerçekleştirilir.',
    ].join('\n'),
  },
  {
    kimlik: 'onay-ve-teyit',
    grup: 'ISLEYIS',
    baslik: 'Onay ve teyit',
    metin: [
      'Teklifi onayladığınızda rezervasyonlarınızı işleme alırız.',
      'Müsaitlik ve fiyat rezervasyon anında yeniden teyit edilir ve değişebilir.',
      'Bu belge bilgilendirme amaçlı fiyat teklifidir, rezervasyon onayı değildir.',
    ].join('\n'),
  },
];

/** Şablonu mevcut metne ekler: metin boşsa şablon olduğu gibi, doluysa yeni satırdan; aynı şablon ikinci kez eklenmez. En çok `azami` karakter. */
export function sablonEkle(mevcut: string, sablon: StandartSablon, azami = 1200): string {
  if (mevcut.includes(sablon.metin)) return mevcut;
  const birlesik = mevcut.trim() === '' ? sablon.metin : `${mevcut.replace(/\s+$/, '')}\n${sablon.metin}`;
  return birlesik.length > azami ? mevcut : birlesik;
}
